module.exports = __webpack_public_path__ + "images/441e2b34eff34204b30b02feeb46b34f-living_alcove.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/living_alcove.jpg
// module id = ./src/assets/images/content/living_alcove.jpg
// module chunks = 0